/**
 * I handle the normalization logic for all "system"-type entities.
 *
 * Keep in mind:
 * - I sanitize and provide safe fallback values for key fields like name, model, serialNumber, and micaType.
 * - I should be imported and assigned as the processStrategy of any schema that represents a system (e.g., systems, userSystems).
 * - Entities that include systems (like users or projects) automatically inherit this logic when referencing the system schema.
 */

import {
  DEFAULT_MICA_TYPE,
  DEFAULT_SERIAL_NUMBER,
  DEFAULT_SYSTEM_MODEL,
  DEFAULT_SYSTEM_NAME
} from 'constants/DefaultMicaValues'

import { VALID_MICA_TYPES } from 'constants/MicaTypes'

export const systemProcessStrategy = value => {
  const micaType = VALID_MICA_TYPES.includes(value?.micaType) ? value.micaType : DEFAULT_MICA_TYPE

  const name =
    typeof value?.name === 'string' && value.name.trim() ? value.name : DEFAULT_SYSTEM_NAME

  const model =
    typeof value?.model === 'string' && value.model.trim() ? value.model : DEFAULT_SYSTEM_MODEL

  const serialNumber =
    typeof value?.serialNumber === 'string' && value.serialNumber.trim()
      ? value.serialNumber
      : DEFAULT_SERIAL_NUMBER

  return {
    ...value,
    serialNumber,
    model,
    name,
    micaType
  }
}
